import { render, staticRenderFns } from "./TetrisPieceContainer.vue?vue&type=template&id=277d79b6&scoped=true"
import script from "./TetrisPieceContainer.vue?vue&type=script&lang=js"
export * from "./TetrisPieceContainer.vue?vue&type=script&lang=js"
import style0 from "./TetrisPieceContainer.vue?vue&type=style&index=0&id=277d79b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d79b6",
  null
  
)

export default component.exports